// extracted by mini-css-extract-plugin
export default {"display":"Display_display__Lb5Km","currentButton":"Display_currentButton__obkEv","mainDisplay":"Display_mainDisplay__yIrwN"};